import { styled } from '@cp/ds/src/theme';
import { Tokens, name } from '../dialog/const';

export const MessageHeader = styled('header', { name, slot: 'header' })({
  display: Tokens.authorNameDisplay('flex'),
  justifyContent: 'flex-start',
  alignItems: 'center',
  alignSelf: 'flex-start',
  fontSize: '12px',
  lineHeight: '14px',
  fontWeight: 500,
  color: Tokens.authorNameText(),
});
